import React, { useState, useRef, useEffect } from 'react';
import { Bell } from 'lucide-react';

export const NotificationDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button 
        className="btn-ghost size-10 relative" 
        onClick={() => setIsOpen(!isOpen)}
      >
        <Bell size={20} />
      </button>
      
      {isOpen && (
        <div className="absolute right-0 mt-2 w-64 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="p-4">
            <div className="flex flex-col items-center justify-center py-6">
              <p className="text-gray-500 text-sm">No notifications</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};